import { FormSelectItem } from "../../../../Blocks/ProvetOnlineBooking/types/formSelectItem";
import { CountryCodeSelectItems } from "./countryCodeSelectItems";

// Split a full phone number into country code and local number
export function splitPhoneNumber(fullNumber: string) {
  if (!fullNumber) {
    return { countryCode: "", localNumber: "" };
  }

  const match = CountryCodeSelectItems.find(item => fullNumber.startsWith(item.value));

  if (match) {
    return {
      countryCode: match.value,
      localNumber: fullNumber.slice(match.value.length)
    };
  }

  return { countryCode: "", localNumber: fullNumber };
}

// Join country code and local number into a single string
export function joinPhoneNumber(countryCode: string, localNumber: string) {
  return `${countryCode}${localNumber}`;
}

// Find country code item by language (e.g., "sv-SE" -> "+46")
export function getCountryCodeByLanguage(language?: string): FormSelectItem {
  if (language) {
    const item = CountryCodeSelectItems.find(
      item => item.categoryValue?.toLowerCase() === language.toLowerCase()
    );

    if (item) {
      return item;
    }
  }

  return CountryCodeSelectItems[0];
}
